export default __webpack_public_path__ + "static/barcelona_code_school_campus_-a3c42b89412ed763aa2d9087b58f974f.jpg";